import type { CSSProperties } from 'react';

export type SwitchButtonStyles = {
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
  heightSlider?: CSSProperties['height'];
  widthSlider?: CSSProperties['width'];
  widthItem?: CSSProperties['width'];
  gapItem?: CSSProperties['gap'];
  background?: string;
  backgroundHover?: string;
  borderRadius?: string;
  color?: string;
  colorHover?: string;
  colorActive?: string;
  colorActiveHover?: string;
  backgroundSlider?: string;
  textSize?: string;
  paddingSlider?: CSSProperties['padding'];
};

export const switchButtonLightStyles: SwitchButtonStyles = {
  height: '6.2rem',
  heightSlider: '5rem',
  widthSlider: '100%',
  widthItem: '50%',
  background: '#ffffff',
  backgroundHover: '#ffffff',
  borderRadius: '3.2rem',
  color: '#868686',
  colorHover: '#131313',
  colorActive: '#ffffff',
  colorActiveHover: '#ffffff',
  backgroundSlider: '#0188FD',
  paddingSlider: '0.6rem',
};
